export default __webpack_public_path__ + "static/media/head03_ja_pc@2x.32194cac.png";